jQuery(document).ready(function () {

    var currentYear = (new Date).getFullYear();

    /* Datepicker Rosenarcade Dauerparker */
    if ('undefined' !== typeof $) {
        $(function() {
            $('form[id*="dauerparkerRosenarcade-"] input[id*="-datepicker-1"]').each(function () {
                $(this).datepicker({
                    dateFormat: 'dd.mm.yy',
                    changeMonth: true,
                    changeYear: true,
                    yearRange: "1940:" + (currentYear - 18)
                }).on('keydown', function(e) {
                    // By using "backspace" or "delete", you can clear the datepicker again.
                    if(e.keyCode === 8 || e.keyCode === 46) {
                        e.preventDefault();
                        $(this).datepicker('setDate', '');
                    }
                });

                console.log($(this).data('format'));
            });

            $('form[id*="dauerparkerRosenarcade-"] input[id*="-datepicker-2"]').each(function () {
                $(this).datepicker({
                    dateFormat: 'dd.mm.yy',
                    changeMonth: true,
                    changeYear: true,
                    yearRange: currentYear + ":" + (currentYear + 2)
                }).on('keydown', function(e) {
                    // By using "backspace" or "delete", you can clear the datepicker again.
                    if(e.keyCode === 8 || e.keyCode === 46) {
                        e.preventDefault();
                        $(this).datepicker('setDate', '');
                    }
                });

                console.log($(this).data('format'));
            });
        });
    }

    $("[data-fancybox]").fancybox({
        iframe : {
            preload : false
        }
    });

    $('a[class*=lightbox]').each(function() {
        var title = $(this).find('img').attr('title');
        $(this).attr('data-caption', title);
    });

    $.fancybox.defaults.btnTpl.print = '<button data-fancybox-print class="fancybox-button fancybox-button--print" title="Bild drucken" style="padding: 16px;">' +
            '<svg id="icon-printer" viewBox="0 0 16 16">' +
                '<path d="M4 16h-4v-10h20v10h-4v4h-12v-4zM6 12v6h8v-6h-8zM4 0h12v5h-12v-5zM2 8v2h2v-2h-2zM6 8v2h2v-2h-2z"></path>' +
            '</svg>' +
        '</button>';

    $('[data-fancybox]').fancybox({
        'buttons': [
            'print',
            'zoom',
            'slideShow',
            'thumbs',
            'close'
        ],
        'iframe': {preload: false},
    });

    $('body').on('click', '[data-fancybox-print]', function() {
        var $image = $('.fancybox-slide.fancybox-slide--current .fancybox-image');
        var url = null;

        if ($image.length > 0) {
            url = $image[0].src;
        }

        if (url) {
            var printWindow = window.open(url, '_blank');
            printWindow.focus();
            printWindow.onload=function(){
                printWindow.print();
            }
        }
    });

    // show on change (for dropdowns)
    $('[data-show-on-change]').on('change', function(e) {
        var instruction = $(this).attr('data-show-on-change');
        var instructionArguments = instruction.split('->');
        var options = instructionArguments[0];
        var targetSelector = instructionArguments[1];

        if ($(targetSelector).length > 0) {
            options = options.split(',');
            $(targetSelector).closest('.form-group').toggle(options.includes($(this).val()));
        }
    }).trigger('change');

    // @deprecated: looks like fancybox2 options -> not used
    var fancyboxOptions = {
        'padding': 15,
        'margin': 20,
        'width': 800,
        'minWidth': 100,
        'minHeight': 100,
        'maxWidth': 9999,
        'maxHeight': 9999,
        'autoSize': true,
        'fitToView': true,
        'aspectRatio': false,
        'topRatio': 0.5,
        'fixed': false,
        'scrolling': 'auto',
        'wrapCSS': '',
        'arrows': true,
        'closeBtn': true,
        'closeClick': false,
        'nextClick': false,
        'mouseWheel': true,
        'loop': true,
        'modal': false,
        'autoPlay': false,
        'playSpeed': 3000,
        'index': 0,
        'type': null,
        'content': null,
        'openEffect': 'fade',
        'closeEffect': 'fade',
        'nextEffect': 'fade',
        'prevEffect': 'fade',
        'openSpeed': 300,
        'closeSpeed': 300,
        'nextSpeed': 300,
        'prevSpeed': 300,
        'openEasing': 'swing',
        'closeEasing': 'swing',
        'nextEasing': 'swing',
        'prevEasing': 'swing',
        'openOpacity': true,
        'closeOpacity': true,
        'openMethod': 'zoomIn',
        'closeMethod': 'zoomOut',
        'nextMethod': 'changeIn',
        'prevMethod': 'changeOut',
        'groupAttr': 'data-fancybox-group',
    };

    if ($('#darksite').length > 0) {

        if (Cookies.get('darksite-' + $('#darksite').attr('data-hash') + '-read') != "true") {
            $("#darksite").modal();

            $('#darksite').on('shown.bs.modal', function () {
                $('#darksite input').trigger('focus');
            });

            $('#darksite').on('hidden.bs.modal', function () {
                var date = new Date();
                // Add one month
                date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
                Cookies.set('darksite-' + $('#darksite').attr('data-hash') + '-read', true, {expires: date});
            });
        }
    }


    // @deprecated: textmedia uses data-fancybox instead, so it seems like this is not used anymore
    jQuery(document).ready(function () {
        jQuery('a[class*=lightbox],a[rel*=lightbox]').fancybox(fancyboxOptions);
    });


    $('.fancybox-container .frame a').click(function (e) {
        location.href = this.href;
    });

    /* init banner swiper */
    const swiperBanner = new Swiper('.banner-swiper', {
        slidesPerView: "1",
        direction: "horizontal",
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    /* init news list swiper */
    var swiperNewsList = new Swiper('.news-swiper', {
        slidesPerView: "1",
        direction: "horizontal",
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            991: {
                slidesPerView: "3",
            },
            767: {
                slidesPerView: "2",
            }
        },
    });

    /* init offer list swiper */
    var swiperOfferList = new Swiper('.offer-swiper', {
        slidesPerView: "1",
        direction: "horizontal",
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1199: {
                slidesPerView: "4",
            },
            991: {
                slidesPerView: "3",
            },
            767: {
                slidesPerView: "2",
            }
        },
    });


    /* init content swiper */
    var swiperContentt = new Swiper('.content-swiper', {
        slidesPerView: "1",
        direction: "horizontal",
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            991: {
                slidesPerView: "3",
            },
            767: {
                slidesPerView: "2",
            }
        },
    });

    $('[data-increase], [data-decrease]').on('click', function(e) {
        e.preventDefault();

        var $target = $($(this).attr('data-target')),
            increase = !!$(this).attr('data-increase'),
            amount = parseInt(increase ? $(this).attr('data-increase') : $(this).attr('data-decrease')),
            min = parseInt($target.attr('min')),
            max = parseInt($target.attr('max'));

        if (amount && $target.length > 0) {
            $target.each(function() {
                var currentValue = parseInt($(this).val());
                if (increase) {
                    if (isNaN(max) || currentValue + amount <= max) {
                        $(this).val(currentValue + amount);
                    }
                } else {
                    if (isNaN(min) || currentValue - amount >= min) {
                        $(this).val(currentValue - amount);
                    }
                }
            });
            $target.trigger('change');
        }
    });

    $('[data-sum-of]').each(function() {
        var $targets = $($(this).attr('data-sum-of')),
            $self = $(this);

        $targets.on('change', calculateSum);
        calculateSum();

        function calculateSum(e)
        {
            var sum = 0;
            $targets.each(function() {
               sum += parseInt($(this).val()) * parseInt($(this).attr('data-value'));
            });

            if (!isNaN(sum)) {
                $self.text(sum + ' €')
            }
        }
    });

    /* close navigation on ESC */
    var mainNavigation = $('#navbarMain');
    if (mainNavigation) {
        mainNavigation.on('show.bs.collapse', function () {
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                    mainNavigation.collapse('hide');
                }
            });
        })
    }

    var dauerparkerIban = document.querySelectorAll('[id*="-ibanID"]');

    if(dauerparkerIban) {
        dauerparkerIban.forEach(function(input) {
            input.addEventListener("input", function(e) {
                let value = e.target.value;

                // Remove any non-alphanumeric characters (like old spaces)
                value = value.replace(/\s+/g, '').replace(/[^A-Za-z0-9]/g, '');

                // Insert a space every 4 characters
                value = value.replace(/(.{4})/g, "$1 ").trim();

                e.target.value = value.toUpperCase();
            });
        });
    }

});

    // create private scope
(function ($) {

    /**
     * Namespace for static utility functions.
     */
    var Utility = {};

    /**
     * Returns the string representation of the given value.
     *
     * @param {*} value The value to return the string representation of
     * @return {string} The string representation of the value
     */
    Utility.strVal = function(value) {
        switch (typeof value) {
            case 'number':
                return value.toString();
            case 'string':
                return value;
            default:
                throw new Error('Unable to cast ' + (typeof value) + ' to string.');
        }
    };

    /**
     * Checks whether a list contains a specific value.
     *
     * @param {number|string} needle The value to search within the list
     * @param {string} haystack The list to search
     * @param {string} [delimiter] The delimiter used to separate values (defaults to a comma)
     * @return {boolean} TRUE if the list contains the given value, otherwise FALSE
     */
    Utility.isInList = function(needle, haystack, delimiter) {
        if ('string' !== typeof haystack) {
            throw new Error('Argument 2 of Utility.isInList has to be of type string, "' + (typeof haystack) + '" given.');
        }
        if ('string' !== typeof delimiter) {
            delimiter = ',';
        }
        return haystack.split(delimiter).indexOf(Utility.strVal(needle)) >= 0;
    };

    /**
     * Component handling notifications.
     * IMPORTANT NOTICE: This component relies on jQuery to a small extend.
     *
     * @constructor
     */
    function NotificationComponent() {

        /**
         * Initializes the component.
         *
         * @private
         */
        function _initialize() {
            var modals = document.querySelectorAll('body > .tx-theme-notifications .modal'),
                triggers = document.querySelectorAll('a[href^="#tx-theme-notification-"]'),
                loaded = false, index;
            for (index = modals.length; index-->0;) {
                var modal = jQuery(modals[index]);
                modal.on('hide.bs.modal', _dismiss.bind(this));
                if ((!!modal.data('autoload') || modal.find('.has-error').length > 0) && !loaded) {
                    loaded = true;
                    modal.modal('show');
                }
            }
            for (index = triggers.length; index-->0;) {
                jQuery(triggers[index]).on('click', _toggle);
            }
        }

        /**
         * Toggles the connected modal.
         *
         * @param {Event} event Corresponding event
         * @private
         */
        function _toggle(event) {
            jQuery(this.hash).modal('toggle');
        }

        /**
         * Dismisses a notification modal.
         *
         * @param {Event} event The corresponding event object
         * @return {Boolean} Continue
         * @private
         */
        function _dismiss(event) {
            var modal = event.target;
                // skip AJAX call if the notification always is visible anyway
            if (1 === parseInt(modal.dataset.persistence, 10)) {
                return true; // continue
            }
            var identifier = parseInt(modal.dataset.identifier, 10);
            if (isNaN(identifier)) {
                return true; // continue
            }

            jQuery.post('/ajax/notification/dismiss', {uid: identifier});
            return true;
        }

            // initialize notifications as soon as the DOM is ready
        if ('interactive' === document.readyState || 'complete' === document.readyState) {
            _initialize.call(this);
        } else {
            document.addEventListener('DOMContentLoaded', _initialize.bind(this));
        }

    }

    /**
     * Component handling shops.
     * IMPORTANT NOTICE: This component does NOT handle center plans. Instances of center plans will be handled through
     * a separate JavaScript file: "~/packages/theme/Resources/Private/JavaScript/Base/center-plan.js".
     *
     * @constructor
     */
    function ShopComponent() {

        /**
         * Filters all shops within the given scope according to the given branch identifier.
         *
         * @param {number|string} branchId The identifier of the branch to filter, or the keyword "all"
         * @param {HTMLElement|string} scope The HTML element or its selector to use as scope
         */
        this.filter = function(branchId, scope) {
            if ('number' !== typeof branchId && 'all' !== branchId) {
                throw new Error('Argument 1 of IGI.Shops.filter has to be either of type number or equal "all", "' + (typeof branchId) + " given.");
            }
            if ('string' === typeof scope) {
                scope = document.querySelector(scope);
            }
            if (!scope) {
                throw new Error('Argument 2 of IGI.Shops.filter has to be a valid HTML element.');
            }

                // filter shops
            var shops = scope.querySelectorAll('[data-shop-branches]'), index = shops.length;
            for (;index-->0;) {
                if ('all' === branchId || Utility.isInList(branchId, shops[index].dataset.shopBranches)) {
                    shops[index].classList.add('show');
                } else {
                    shops[index].classList.remove('show');
                }
            }

                // mark branch as active
            var branches = scope.querySelectorAll('[data-filter-branch]');
            for (index = branches.length; index-->0;) {
                if (Utility.isInList(branchId, branches[index].dataset.filterBranch)) {
                    branches[index].classList.remove('btn-light');
                    branches[index].classList.add('btn-dark');
                } else {
                    branches[index].classList.remove('btn-dark');
                    branches[index].classList.add('btn-light');
                }
            }
        };

    }

        // export to global scope
    window.IGI = window.IGI || {};
    window.IGI.Notifications = new NotificationComponent();
    window.IGI.Shops = new ShopComponent();

})(jQuery);

document.addEventListener("DOMContentLoaded", function(event) {
    var creditIframe = document.getElementsByClassName("credit-check-iframe")[0];
    if (creditIframe && typeof validateCard === "function"){
        var apiKey = creditIframe.dataset['apiKey'];
        window.validateCard = new validateCard(
            "#validate-card",
            apiKey
        );
        window.validateCard.init();
    }
});